// @flow
type T_BET_MODULE_NAME = 'BET_MODULE';
const BET_MODULE_NAME: T_BET_MODULE_NAME = 'BET_MODULE';

const MAX_CHIPS_COUNT = 3;
const MAX_FREQUENCY = 3;

export {BET_MODULE_NAME, MAX_CHIPS_COUNT, MAX_FREQUENCY};
export type {T_BET_MODULE_NAME};
